/**
 * Payment Service
 * Handles all payment-related API calls
 */

import { customersApiClient } from './apiClient';

const PAYMENT_METHODS_ENDPOINT = '/payment-methods';

export const paymentService = {
  /**
   * Store a new payment card
   * @param {Object} cardData - Card data from payment processor
   */
  async storeCard(cardData) {
    const payload = {
      payment_method_type: 'Card',
      card_id: cardData.squareToken,
      square_token: cardData.squareToken,
      display_name: cardData.displayName,
      metadata: JSON.stringify(cardData.metadata || {}),
      is_default: cardData.isDefault || false,
    };

    const result = await customersApiClient.post(PAYMENT_METHODS_ENDPOINT, payload);

    if (!result.success) {
      return {
        success: false,
        data: null,
        error: result.error || 'Failed to store card',
      };
    }

    return {
      success: true,
      data: result.data,
      replacedIds: result.data?.replaced_payment_method_ids || [],
      error: null,
    };
  },

  /**
   * Get all saved payment methods for user
   */
  async getPaymentMethods() {
    const result = await customersApiClient.get(PAYMENT_METHODS_ENDPOINT);

    if (!result.success) {
      return {
        success: false,
        data: [],
        error: result.error || 'Failed to fetch payment methods',
      };
    }

    const methods = result.data?.payment_methods || result.data || [];

    return {
      success: true,
      data: Array.isArray(methods) ? methods : [],
      error: null,
    };
  },

  /**
   * Delete a saved payment method
   * @param {string|number} paymentMethodId
   */
  async deletePaymentMethod(paymentMethodId) {
    const result = await customersApiClient.delete(`${PAYMENT_METHODS_ENDPOINT}/${paymentMethodId}`);

    if (!result.success) {
      return {
        success: false,
        error: result.error || 'Failed to delete payment method',
      };
    }

    return {
      success: true,
      error: null,
    };
  },

  /**
   * Set a payment method as default
   * @param {string|number} paymentMethodId
   */
  async setDefaultPaymentMethod(paymentMethodId) {
    const result = await customersApiClient.post(`${PAYMENT_METHODS_ENDPOINT}/${paymentMethodId}/set-default`);

    if (!result.success) {
      return {
        success: false,
        error: result.error || 'Failed to set default payment method',
      };
    }

    return {
      success: true,
      error: null,
    };
  },
};

export default paymentService;
